import { KeyValue } from '@/main/models/common';
import { CompanyTypes, CompanyActionTypes } from './companyTypes';
import { CompanyFilterRequest } from '@/main/models/request';

export function getCompany(
  request: CompanyFilterRequest,
  keyReducer: string = 'default'
): CompanyActionTypes {
  return {
    type: CompanyTypes.GET_COMPANY,
    payload: { request, keyReducer }
  };
}

export function getCompanyAll(
  request: CompanyFilterRequest,
  keyReducer: string = 'default'
): CompanyActionTypes {
  return {
    type: CompanyTypes.GET_COMPANY_ALL,
    payload: { request, keyReducer }
  };
}

export function saveCompany(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): CompanyActionTypes {
  return {
    type: CompanyTypes.SAVE_COMPANY,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function saveCompanyAll(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): CompanyActionTypes {
  return {
    type: CompanyTypes.SAVE_COMPANY_ALL,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerCompany(): CompanyActionTypes {
  return {
    type: CompanyTypes.RESET_REDUCER_COMPANY
  };
}

